import { z } from 'zod';
/** Any value that survives a JSON round trip. */
export const JsonValueSchema = z.json();
//# sourceMappingURL=jsonValue.js.map